/**
 * LES COULEURS DES TROIS PILIERS — la signature visuelle de Gively.
 * Vente = bleu · Location = violet · Services = vert.
 *
 * Source UNIQUE (30/09/2026) : déplacée depuis
 * `pages/publish/components/teintes.js`, qui importait le contexte du tunnel de
 * publication et ne pouvait donc pas servir à l'accueil ni au tunnel d'achat.
 * Ce module ne dépend de rien.
 *
 * `vif`   → trait, fond plein d'un bouton sélectionné, puce décorative.
 * `texte` → tout ce qui s'ÉCRIT dans la teinte (contraste AA sur blanc mesuré :
 *           #0B6FA4 = 5,49:1 · #7C3AED = 5,70:1 · #047857 = 5,48:1). Le vert
 *           vif #0E9F6E ne fait que 3,39:1 : trait uniquement, jamais texte ni
 *           fond sous un texte blanc.
 * `pale`  → bordure douce, étape franchie.
 * `fond`  → surface sélectionnée.
 * `free` (objet offert) partage la teinte de la vente.
 */
export const TEINTE_PILIER = {
  sale: { vif: "#0B6FA4", texte: "#0B6FA4", pale: "#BFE3F5", fond: "#EFF8FC" },
  free: { vif: "#0B6FA4", texte: "#0B6FA4", pale: "#BFE3F5", fond: "#EFF8FC" },
  rental: { vif: "#7C3AED", texte: "#7C3AED", pale: "#DDD6FE", fond: "#F5F3FF" },
  service: { vif: "#0E9F6E", texte: "#047857", pale: "#A7F3D0", fond: "#ECFDF5" },
};

// Défaut prudent : un type inconnu retombe sur la vente.
export function teintePilier(type) {
  return TEINTE_PILIER[type] || TEINTE_PILIER.sale;
}
